module.exports = __webpack_public_path__ + "assets/8e568078e23388433c866e6a584f8f43.mp4";